import type { MpSandboxConfigWire } from "../../../lib/multiplayer/protocol";

export type MpModeBridge = {
  buildSpeedrunLevelGridForMp: (onSelect: (level: number) => void, selectedLevel: number | null) => void;
  openMpSpeedrunLevelScreen: () => void;
  openMpSandboxScreen: () => void;
  collectSandboxConfigWire: () => MpSandboxConfigWire;
  applySandboxConfigWire: (config: MpSandboxConfigWire) => void;
  prepareMpSpeedrunGame: (level: number) => void;
  prepareMpSandboxGame: (config: MpSandboxConfigWire) => void;
  prepareMpHighwayGame: () => void;
  applyHighwayWireSnapshot: (snap: {
    cameraY: number;
    obstacles: unknown[];
    nextSpawnWorldY: number;
  }) => void;
  isMpHighwayMode: () => boolean;
  isMpSpeedrunMode: () => boolean;
  getMpHighwayCursorScreen: () => { x: number; y: number };
  setSandboxMpHostOnly: (isHost: boolean) => void;
};

let bridge: MpModeBridge | null = null;

export function registerMpModeBridge(b: MpModeBridge): void {
  bridge = b;
}

export function mpModeBridge(): MpModeBridge | null {
  return bridge;
}
